module.exports = __webpack_public_path__ + "img/Ola.9e6b60f3.jpg";